// This client was automatically generated by Segment Typewriter. ** Do Not Edit **
// To update this file, run:
//   npx typewriter

/**
 * Ýtt á takka
 */
export interface ButtonClicked {
  /**
   * Texti á takka
   */
  text: string;
  /**
   * Hlekkur á takka
   */
  url?: string;
  [property: string]: any;
}

/**
 * Hafðu samband form sent
 */
export interface ContactUsFormSubmitted {
  /**
   * Fá svar með tölvupósti
   */
  answerByEmail: boolean;
  /**
   * Fá svar í síma
   */
  answerByPhone: boolean;
  /**
   * Hvert er erindið
   */
  subject: string;
  /**
   * Titill síðu
   */
  title: string;
  [property: string]: any;
}

/**
 * Ýtt á Komdu í viðskipti takka
 */
export interface DoBusinessWithUsButtonClicked {
  /**
   * Staðsetning takka (í header navigation, footer o.fl.)
   */
  placement: Placement;
  /**
   * The text "Komdu í viðskipti"
   */
  title: Title;
  [property: string]: any;
}

/**
 * Staðsetning takka (í header navigation, footer o.fl.)
 */
export enum Placement {
  Footer = 'footer',
  Header = 'header',
  PackageCard = 'packageCard',
  BentoBox = 'bentoBox',
  PhotoAndTextCard = 'photoAndTextCard',
  CardButton = 'cardButton',
}

/**
 * The text "Komdu í viðskipti"
 */
export enum Title {
  KomduÍViðskipti = 'Komdu í viðskipti',
  CallMe = 'Fá samtal',
}

/**
 * Komdu í viðskipti form sent
 */
export interface DoBusinessWithUsFormSubmitted {
  /**
   * Tegund (heimili eða fyrirtæki)
   */
  type: DoBusinessWithUsFormSubmittedType;
  [property: string]: any;
}

/**
 * Tegund (heimili eða fyrirtæki)
 */
export enum DoBusinessWithUsFormSubmittedType {
  Company = 'Company',
  Home = 'Home',
  CallMe = 'CallMe',
}

/**
 * Smellt á module
 */
export interface ModuleClicked {
  /**
   * Einkvæmt auðkenni module
   */
  moduleId: string;
  /**
   * Texti á module
   */
  text: string;
  /**
   * Titill síðu
   */
  title: string;
  /**
   * Hlekkur á module
   */
  url: string;
  [property: string]: any;
}

/**
 * Ýtt á takka í packageCard
 */
export interface PackageCardButtonClicked {
  /**
   * Titill á pakka
   */
  package: string;
  /**
   * Staðsetning korts, t.d. í pakkatillöguformi
   */
  source?: Source;
  /**
   * Titill á takka (oftast Panta eða Sjá nánar)
   */
  title: string;
  /**
   * Primary fyrir takkann aðaltakkann (Panta) og Secondary fyrir hinn (Sjá nánar)
   */
  type: PackageCardButtonClickedType;
  [property: string]: any;
}

/**
 * Staðsetning korts, t.d. í pakkatillöguformi
 */
export enum Source {
  PackageSuggestionForm = 'packageSuggestionForm',
}

/**
 * Primary fyrir takkann aðaltakkann (Panta) og Secondary fyrir hinn (Sjá nánar)
 */
export enum PackageCardButtonClickedType {
  Primary = 'primary',
  Secondary = 'secondary',
}

/**
 * Pakkaform sent
 */
export interface PackageFormSubmitted {
  /**
   * Titill á pakka
   */
  package: string;
  [property: string]: any;
}

/**
 * Farið á skref í pakkatillöguformi
 */
export interface PackageSuggestionStepViewed {
  /**
   * Skref númer x valið
   */
  step: number;
  /**
   * Nafn á skrefi sem var valið
   */
  stepTitle?: string;
  [property: string]: any;
}

/**
 * Ajv is a peer dependency for development builds. It's used to apply run-time validation
 * to message payloads before passing them on to the underlying analytics instance.
 *
 * Note that the production bundle does not depend on Ajv.
 *
 * You can install it with: `npm install --save-dev ajv`.
 */
import Ajv, { ErrorObject } from 'ajv';

/**
 * The analytics.js snippet should be available via window.analytics.
 * You can install it by following instructions at: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 * Make sure to also include the TypeScript declarations with: `npm install @segment/analytics-next` (install with --save-dev for type definitions only).
 *
 * If you don't want to use the snippet, you can also install the `@segment/analytics-next` library as a *production* dependency and use it like this:
 * ```ts
 * import { AnalyticsBrowser } from '@segment/analytics-next'
 * import { setTypewriterOptions } from './analytics'
 *
 * const analytics = AnalyticsBrowser.load({ writeKey: 'SEGMENT_WRITE_KEY' })
 *
 * setTypewriterOptions({ analytics: analytics })
 */
import type { AnalyticsSnippet, Analytics, AnalyticsBrowser, Options } from '@segment/analytics-next';

declare global {
  interface Window {
    analytics: AnalyticsSnippet;
  }
}

type AnyAnalytics = AnalyticsSnippet | Analytics | AnalyticsBrowser;

/** The callback exposed by analytics.js. */
export type Callback = () => void;

export type ViolationHandler = (message: Record<string, any>, violations: ErrorObject[]) => void;

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (message, violations) => {
  const msg = JSON.stringify(
    {
      type: 'Typewriter JSON Schema Validation Error',
      description:
        `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
        'Tracking Plan spec.',
      errors: violations,
    },
    undefined,
    2
  );

  console.warn(msg);
};

let onViolation = defaultValidationErrorHandler;

let analytics: () => AnyAnalytics | undefined = () => {
  return window.analytics;
};

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
  /**
   * Underlying analytics instance where analytics calls are forwarded on to.
   * Defaults to window.analytics.
   */
  analytics?: AnyAnalytics;
  /**
   * Handler fired when if an event does not match its spec. This handler
   * does not fire in production mode, because it requires inlining the full
   * JSON Schema spec for each event in your Tracking Plan.
   *
   * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
   * if a message does not match the spec. Otherwise, errors will be logged to stderr.
   */
  onViolation?: ViolationHandler;
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
  analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
  onViolation = options.onViolation || onViolation;
}

/**
 * Validates a message against a JSON Schema using Ajv. If the message
 * is invalid, the `onViolation` handler will be called.
 */
function validateAgainstSchema(message: Record<string, any>, schema: object) {
  const ajv = new Ajv({ allErrors: true, verbose: true });

  if (!ajv.validate(schema, message) && ajv.errors) {
    onViolation(message, ajv.errors);
  }
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Options = {}): Options {
  return {
    ...message,
    context: {
      ...(message.context || {}),
      typewriter: {
        language: 'typescript',
        version: '9.1.0',
      },
    },
  };
}

/**
 * Fires a 'ButtonClicked' track call.
 *
 * @param ButtonClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function buttonClicked(props: ButtonClicked, options?: Options, callback?: Callback): void {
  const schema = {
    $id: 'buttonClicked',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Ýtt á takka',
    properties: {
      text: { $id: '/properties/text', description: 'Texti á takka', type: 'string' },
      url: { $id: '/properties/url', description: 'Hlekkur á takka', type: 'string' },
    },
    required: ['text'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'buttonClicked',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'ContactUsFormSubmitted' track call.
 *
 * @param ContactUsFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contactUsFormSubmitted(props: ContactUsFormSubmitted, options?: Options, callback?: Callback): void {
  const schema = {
    $id: 'contactUsFormSubmitted',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Hafðu samband form sent',
    properties: {
      answerByEmail: { $id: '/properties/answerByEmail', description: 'Fá svar með tölvupósti', type: 'boolean' },
      answerByPhone: { $id: '/properties/answerByPhone', description: 'Fá svar í síma', type: 'boolean' },
      subject: { $id: '/properties/subject', description: 'Hvert er erindið', type: 'string' },
      title: { $id: '/properties/title', description: 'Titill síðu', type: 'string' },
    },
    required: ['subject', 'answerByEmail', 'answerByPhone', 'title'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'contactUsFormSubmitted',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'DoBusinessWithUsButtonClicked' track call.
 *
 * @param DoBusinessWithUsButtonClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function doBusinessWithUsButtonClicked(
  props: DoBusinessWithUsButtonClicked,
  options?: Options,
  callback?: Callback
): void {
  const schema = {
    $id: 'doBusinessWithUsButtonClicked',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Ýtt á Komdu í viðskipti takka',
    properties: {
      placement: {
        $id: '/properties/placement',
        description: 'Staðsetning takka (í header navigation, footer o.fl.)',
        enum: ['footer', 'header', 'packageCard', 'photoAndTextCard'],
        type: 'string',
      },
      title: {
        $id: '/properties/title',
        description: 'The text "Komdu í viðskipti"',
        enum: ['Komdu í viðskipti'],
        type: 'string',
      },
    },
    required: ['placement', 'title'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'doBusinessWithUsButtonClicked',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'DoBusinessWithUsFormSubmitted' track call.
 *
 * @param DoBusinessWithUsFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function doBusinessWithUsFormSubmitted(
  props: DoBusinessWithUsFormSubmitted,
  options?: Options,
  callback?: Callback
): void {
  const schema = {
    $id: 'doBusinessWithUsFormSubmitted',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Komdu í viðskipti form sent',
    properties: {
      type: {
        $id: '/properties/type',
        description: 'Tegund (heimili eða fyrirtæki)',
        enum: ['Company', 'Home', 'CallMe'],
        type: 'string',
      },
    },
    required: ['type'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'doBusinessWithUsFormSubmitted',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'ModuleClicked' track call.
 *
 * @param ModuleClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function moduleClicked(props: ModuleClicked, options?: Options, callback?: Callback): void {
  const schema = {
    $id: 'moduleClicked',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Smellt á module',
    properties: {
      moduleId: { $id: '/properties/moduleId', description: 'Einkvæmt auðkenni module', type: 'string' },
      text: { $id: '/properties/text', description: 'Texti á module', type: 'string' },
      title: { $id: '/properties/title', description: 'Titill síðu', type: 'string' },
      url: { $id: '/properties/url', description: 'Hlekkur á module', type: 'string' },
    },
    required: ['text', 'url', 'moduleId', 'title'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'moduleClicked',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'PackageCardButtonClicked' track call.
 *
 * @param PackageCardButtonClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function packageCardButtonClicked(
  props: PackageCardButtonClicked,
  options?: Options,
  callback?: Callback
): void {
  const schema = {
    $id: 'packageCardButtonClicked',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Ýtt á takka í packageCard',
    properties: {
      package: { $id: '/properties/package', description: 'Titill á pakka', type: 'string' },
      source: {
        $id: '/properties/source',
        description: 'Staðsetning korts, t.d. í pakkatillöguformi',
        enum: ['packageSuggestionForm'],
        type: 'string',
      },
      title: { $id: '/properties/title', description: 'Titill á takka (oftast Panta eða Sjá nánar)', type: 'string' },
      type: {
        $id: '/properties/type',
        description: 'Primary fyrir takkann aðaltakkann (Panta) og Secondary fyrir hinn (Sjá nánar)',
        enum: ['primary', 'secondary'],
        type: 'string',
      },
    },
    required: ['package', 'title', 'type'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'packageCardButtonClicked',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'PackageFormSubmitted' track call.
 *
 * @param PackageFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function packageFormSubmitted(props: PackageFormSubmitted, options?: Options, callback?: Callback): void {
  const schema = {
    $id: 'packageFormSubmitted',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Pakkaform sent',
    properties: { package: { $id: '/properties/package', description: 'Titill á pakka', type: 'string' } },
    required: ['package'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'packageFormSubmitted',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}
/**
 * Fires a 'PackageSuggestionStepViewed' track call.
 *
 * @param PackageSuggestionStepViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function packageSuggestionStepViewed(
  props: PackageSuggestionStepViewed,
  options?: Options,
  callback?: Callback
): void {
  const schema = {
    $id: 'packageSuggestionStepViewed',
    $schema: 'http://json-schema.org/draft-07/schema#',
    description: 'Farið á skref í pakkatillöguformi',
    properties: {
      step: { $id: '/properties/step', description: 'Skref númer x valið', type: 'integer' },
      stepTitle: { $id: '/properties/stepTitle', description: 'Nafn á skrefi sem var valið', type: 'string' },
    },
    required: ['step'],
    type: 'object',
  };
  validateAgainstSchema(props, schema);

  const a = analytics();
  if (a) {
    a.track(
      'packageSuggestionStepViewed',
      props || {},
      {
        ...options,
        context: {
          ...(options?.context || {}),
          typewriter: {
            language: 'typescript',
            version: '',
          },
        },
      },
      callback
    );
  }
}

const clientAPI = {
  /**
   * Updates the run-time configuration of this Typewriter client.
   *
   * @param {TypewriterOptions} options - the options to upsert
   *
   * @typedef {Object} TypewriterOptions
   * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setTypewriterOptions,

  /**
   * Fires a 'ButtonClicked' track call.
   *
   * @param ButtonClicked props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  buttonClicked,
  /**
   * Fires a 'ContactUsFormSubmitted' track call.
   *
   * @param ContactUsFormSubmitted props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  contactUsFormSubmitted,
  /**
   * Fires a 'DoBusinessWithUsButtonClicked' track call.
   *
   * @param DoBusinessWithUsButtonClicked props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  doBusinessWithUsButtonClicked,
  /**
   * Fires a 'DoBusinessWithUsFormSubmitted' track call.
   *
   * @param DoBusinessWithUsFormSubmitted props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  doBusinessWithUsFormSubmitted,
  /**
   * Fires a 'ModuleClicked' track call.
   *
   * @param ModuleClicked props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  moduleClicked,
  /**
   * Fires a 'PackageCardButtonClicked' track call.
   *
   * @param PackageCardButtonClicked props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  packageCardButtonClicked,
  /**
   * Fires a 'PackageFormSubmitted' track call.
   *
   * @param PackageFormSubmitted props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  packageFormSubmitted,
  /**
   * Fires a 'PackageSuggestionStepViewed' track call.
   *
   * @param PackageSuggestionStepViewed props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 	call is fired.
   */
  packageSuggestionStepViewed,
};

export default new Proxy<typeof clientAPI>(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method as keyof typeof clientAPI];
    }

    return () => {
      console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
         a) Re-generate your typewriter client: \`npx typewriter\`
         b) Add it to your Tracking Plan: https://app.segment.com/segment-oscb/protocols/tracking-plans/rs_1zTHJU9fd5mt7cndWnd4PgJbMCE`);
      const a = analytics();
      if (a) {
        a.track(
          'Unknown Analytics Call Fired',
          {
            method,
          },
          withTypewriterContext()
        );
      }
    };
  },
});
